import { useState } from "react";
import { IValueList, IValueListAdminQuery } from "../../../types/valuelist";
import AccordionContainer from "../../common/accordion-container";
import QueryScriptPane from "./query-script-pane";
import SavedQueriesTable from "./saved-queries-table";
import './style.scss';

export default function QueryProvider() {
  const [selectedItem, setSelectedItem] = useState<IValueListAdminQuery>();

  return (
    <>
      <AccordionContainer title="Saved Queries">
        <SavedQueriesTable onSelect={setSelectedItem}></SavedQueriesTable>
      </AccordionContainer>

      <QueryScriptPane data={selectedItem} key={selectedItem?.id} />
    </>
  );
}
